import {ConfigInterface} from "../../config";
import {ChatRoomInfo, useApiCall, useApiEndpoint} from "../../api";

export function useChatRoomsInfo(config: ConfigInterface): {chatRooms: ChatRoomInfo[]} {
  const {chat} = useApiCall(config)
  const {resource} = useApiEndpoint(() => chat.all())

  return {chatRooms: resource ?? []}
}